var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.moved && _vm.received)?_c('div',{staticClass:"rounded-circle bg-warning coin border",class:{ pressed: _vm.isPressed, moved: _vm.moved,  'click-disabled': !_vm.isCurrentPlayer || !_vm.running},on:{"click":_vm.press}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }